import { render } from "./CustomerDeletePage.vue?vue&type=template&id=2ff7827c"
import script from "./CustomerDeletePage.vue?vue&type=script&lang=js"
export * from "./CustomerDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__